import { Grid } from "@mui/material"
import ItemServices from "../items_services/ItemServices"

export const ShareRateCard=()=>{
    return (
        <Grid container sx={{p:"10px"}}>
            <Grid>
               
                 <ItemServices  config={{addBtn:false,isCheckBox:true}}/>
            </Grid>
        </Grid>
    )
}